import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { createSelector } from 'reselect';

import { getCoursesLoadingStatus } from 'store/courses/selectors';

export const getShouldShowPageSpinner = createSelector(
    [getCoursesLoadingStatus],
    (loadingStatus: LOADING_STATUSES): boolean => {
        return loadingStatus !== LOADING_STATUSES.SUCCESS;
    }
);
